import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const STORAGE_KEY = 'soc.selectedProjectId';

interface ProjectsState {
  /** Currently-active project. Detection + queries are scoped to its polygon. */
  selectedId: string | null;
}

function loadSelectedId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

const initialState: ProjectsState = { selectedId: loadSelectedId() };

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    selectProject(state, action: PayloadAction<string | null>) {
      state.selectedId = action.payload;
      try {
        if (action.payload) localStorage.setItem(STORAGE_KEY, action.payload);
        else localStorage.removeItem(STORAGE_KEY);
      } catch {
        /* ignore storage failures */
      }
    },
  },
});

export const { selectProject } = projectsSlice.actions;
export default projectsSlice.reducer;
